module.exports = __webpack_public_path__ + "static/media/adjustments.8e709d03.svg";